import ReactDOM from 'react-dom/client';
import React from 'react';
export const NavBrand =  ()=>{
    return (
        <a className="navbar-brand" href="/tcgcreatoreternalbetaver2">Tcgcreator eternal beta</a>
    )
}
